<template>
  <v-app>
    <v-main>
      <RouterView />
    </v-main>

    <Toaster position="top-right" rich-colors />

    <DeepReloadPrompt v-if="!isLocalEnv()" />

    <DeepLoader />

    <LandscapeHint v-if="isLandscape" :show="isLandscape" />
  </v-app>
</template>
<script setup lang="ts">
import 'vue-sonner/style.css'
import { Toaster } from 'vue-sonner'
import { DeepLoader, DeepReloadPrompt } from '@deepcloud/deep-ui-lib'
import { getAppWindowTitle, isLocalEnv } from '@/util/env.ts'
import { useOrientation } from '@/composables/use-orientation.ts'
import LandscapeHint from '@/components/app/LandscapeHint.vue'

const isLandscape = useOrientation()

document.title = getAppWindowTitle()
</script>
